<script>
import EgFormGroup from "@/components/global/eg_form_group.vue";
import { createLetterOfRecommendation } from "@/api/requests/freeTools";
import FreeToolsWrapper from "@/views/free-tools/free-tools-wrapper.vue";
import EgDropdown from "@/components/global/eg_dropdown.vue";

const pronounces = ["She/Her/Hers", "He/Him/His", "They/Them/Theirs"];

export default {
  name: "LetterOfRecommendation",
  components: {
    EgDropdown,
    FreeToolsWrapper,
    EgFormGroup,
  },
  data() {
    return {
      institution: "",
      name: "",
      pronounces,
      pronouns: pronounces[0],
      relationship: "",
      info: "",
      loading: false,
      letter: null,
    };
  },
  methods: {
    fill() {
      this.institution = "Metro State University";
      this.name = "Sara Jones";
      this.pronouns = pronounces[0];
      this.relationship = "Teacher";
      this.info = `
Earned All-A honor roll for 5 consecutive quarters
Won first place in school science fair for "Designing a Sustainable Water Purification System"
Completed advanced reading program and read 6 books beyond classroom assignment
`.trim();
    },
    async generate() {
      this.loading = true;
      try {
        this.letter = null;
        const { data } = await createLetterOfRecommendation({
          institution: this.institution,
          relationship: this.relationship,
          info: this.info,
          pronouns: this.pronouns,
          name: this.name,
        });
        this.letter = data.response;
      } finally {
        this.loading = false;
        this.$nextTick(() => {
          this.$refs.freeToolsWrapper.notifyResize();
        });
      }
    },
  },
};
</script>

<template>
  <FreeToolsWrapper ref="freeToolsWrapper">
    <div>
      <h3>{{ $t("freeTools.letterOfRecommendation.title") }}</h3>
      <p>
        {{ $t("freeTools.letterOfRecommendation.description") }}
      </p>
      <eg-form-group
        :label="$t('freeTools.letterOfRecommendation.institution')"
        required
      >
        <eg-b-form-input
          v-model="institution"
          :placeholder="
            $t('freeTools.letterOfRecommendation.institutionPlaceholder')
          "
        />
      </eg-form-group>
      <eg-form-group
        :label="$t('freeTools.letterOfRecommendation.studentName')"
        required
      >
        <eg-b-form-input
          v-model="name"
          :placeholder="
            $t('freeTools.letterOfRecommendation.studentNamePlaceholder')
          "
        />
      </eg-form-group>
      <eg-form-group
        :label="$t('freeTools.letterOfRecommendation.studentPronouns')"
        required
      >
        <eg-dropdown :text="pronouns">
          <eg-b-dropdown-item-button
            v-for="p in pronounces"
            :key="p"
            @click="pronouns = p"
          >
            {{ p }}
          </eg-b-dropdown-item-button>
        </eg-dropdown>
      </eg-form-group>
      <eg-form-group
        :label="$t('freeTools.letterOfRecommendation.relationship')"
        required
      >
        <eg-b-form-input
          v-model="relationship"
          :placeholder="
            $t('freeTools.letterOfRecommendation.relationshipPlaceholder')
          "
        />
      </eg-form-group>
      <eg-form-group
        :label="$t('freeTools.letterOfRecommendation.importantInfo')"
        required
      >
        <eg-b-textarea
          v-model="info"
          :placeholder="
            $t('freeTools.letterOfRecommendation.importantInfoPlaceholder')
          "
          :rows="5"
        />
      </eg-form-group>
      <div
        class="d-flex justify-content-center align-items-center flex-gap-1 mb-3"
      >
        <eg-b-button :disabled="loading" class="large outline" @click="fill">
          {{ $t("freeTools.useExample") }}
        </eg-b-button>
        <eg-b-button :disabled="loading" class="button large" @click="generate">
          <eg-b-spinner v-show="loading" small />
          {{ $t("common.generate") }}
        </eg-b-button>
      </div>
    </div>
    <div v-if="letter">
      <div class="letter panel">
        {{ letter }}
      </div>
    </div>
  </FreeToolsWrapper>
</template>

<style scoped lang="scss">
.letter {
  white-space: pre-line;
}
</style>
